import React from 'react';
import AthleticBrewing from 'src/images/2024_Q1_people_magic/Logos/AthleticBrewing';
import TED from 'src/images/2024_Q1_people_magic/Logos/TED';
import KonMari from 'src/images/2024_Q1_people_magic/Logos/KonMari';
import MatthewHussey from 'src/images/2024_Q1_people_magic/Logos/MatthewHussey';
import MelRobbins from 'src/images/2024_Q1_people_magic/Logos/MelRobbins';
import Mindbody from 'src/images/2024_Q1_people_magic/Logos/Mindbody';
import TheBudgetnista from 'src/images/2024_Q1_people_magic/Logos/TheBudgetnista';
import MarieForleo from 'src/images/2024_Q1_people_magic/Logos/MarieForleo';
import Keap from 'src/images/2024_Q1_people_magic/Logos/Keap';
import BODi from 'src/images/2024_Q1_people_magic/Logos/BODi';
import LogoShowcaseRail from './LogoShowcaseRail';

const DEFAULT_FADE_ELEMENT_COLOR = 'linear-gradient(90deg, rgba(11, 73, 77, 0.00) 0%, #0B494D 33.81%)';

interface LogoShowcaseAutoScrollProps {
  fadeElementColor?: string;
}

const LogoShowcaseAutoScroll = ({
  fadeElementColor = DEFAULT_FADE_ELEMENT_COLOR,
}: LogoShowcaseAutoScrollProps): JSX.Element => {
  const logos = [
    TED,
    KonMari,
    MatthewHussey,
    MelRobbins,
    BODi,
    AthleticBrewing,
    Mindbody,
    TheBudgetnista,
    MarieForleo,
    Keap,
  ];

  return (
    <LogoShowcaseRail
      fadeElementColor={fadeElementColor}
      logos={logos}
    />
  );
};

export default LogoShowcaseAutoScroll;
